import { Button, Card } from '@repo/shadcn';

import { SectionContainer } from '@components/shared';
import {
    HeaderBreadcrumb,
    SectionDataTable,
    SectionTitle,
} from '@components/ui';

import { CustomerListFilters } from '@/modules/customers/customer-list/customer-list-filters.component';
import { customerListColumns } from '@/modules/customers/customer-list/customer-list.column';
import { useCustomerList } from '@/modules/customers/customer-list/customer-list.hook';

export const CustomerList = () => {
    const { data, isError, isLoading, error, isFetching, handleAddCustomer } =
        useCustomerList();
    return (
        <SectionContainer error={error} isError={isError} isLoading={isLoading}>
            <Card className="min-w-0 space-y-4 overflow-hidden p-3 sm:p-4">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                    <div className={'space-y-4'}>
                        <HeaderBreadcrumb items={[{ label: 'Customers' }]} />
                        <SectionTitle>Customers</SectionTitle>
                    </div>
                    <Button
                        type={'button'}
                        className="w-full sm:w-auto"
                        onClick={handleAddCustomer}
                    >
                        Add Customer
                    </Button>
                </div>
                <CustomerListFilters />
                <div className="min-w-0 [&_[role=navigation]>ul]:min-w-max [&_[role=navigation]]:justify-start [&_[role=navigation]]:overflow-x-auto sm:[&_[role=navigation]]:justify-center">
                    <SectionDataTable
                        columns={customerListColumns}
                        data={data}
                        isLoading={isLoading || isFetching}
                    />
                </div>
            </Card>
        </SectionContainer>
    );
};

CustomerList.displayName = 'CustomerList';
